import {type ComputedRef, isRef} from 'vue';

interface FormatOptions {
    currency?: string;
    locale?: string;
    decimals?: number;
}

export function useFormatting() {
    const defaultOptions: FormatOptions = {
        currency: 'EUR',
        locale: 'nl-BE',
        decimals: 2
    };

    const createFormatter = (options: FormatOptions = {}) => {
        const { currency, locale, decimals } = { ...defaultOptions, ...options };

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    };

    const formatCurrency = (
        value: number | ComputedRef<number | undefined> | undefined,
        options?: FormatOptions
    ): string => {
        const amount = isRef(value) ? (value.value ?? 0) : (value ?? 0);
        return createFormatter(options).format(amount);
    };

    return {
        formatCurrency
    };
}
